<template>
  <!-- 輸入 email 階段 -->
  <div v-if="isState('emailInput')">
    <div class="flex flex-col gap-2 w-full">
      <h1 class="text-2xl font-semibold tracking-tight">
        {{ t("forgetPassword.forgetPassword") }}
      </h1>
      <p>
        {{ t("forgetPassword.forgotPasswordDesc") }}
      </p>
    </div>
    <form @submit="onSubmit" class="w-full">
      <div class="grid gap-4 py-4">
        <FormField v-slot="{ componentField }" name="email">
          <FormItem>
            <FormLabel>{{ t("forgetPassword.email") }} </FormLabel>
            <FormControl>
              <Input
                v-bind="componentField"
                :placeholder="t('forgetPassword.enterEmail')"
                class=" bg-transparent h-10"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        </FormField>

        <div class="flex sm:gap-3">
          <Button
            variant="outline"
            type="button"
            @click="onCancel"
            class="flex-1 h-[46px] border-white hover:bg-transparent/0"
          >
            {{ t("forgetPassword.cancel") }}
          </Button>
          <Button type="submit" class="flex-1 h-[45px]" :disabled="!!errors.email">
            {{ t("forgetPassword.send") }}
          </Button> 
        </div>
      </div>
    </form>
  </div>

  <!-- 郵件已發送階段 -->
  <div v-else-if="isState('emailSent')" class="flex flex-col gap-4 w-full">
    <div class="flex flex-col gap-2 w-full">
      <h1 class="text-2xl font-semibold tracking-tight">
        {{ t("forgetPassword.resetPasswordEmailSent") }}
      </h1>
      <p>
        {{ t("forgetPassword.checkEmailFollowInstruction") }}
      </p>
      <div class="mt-2 text-sm text-gray-400">
        {{ userEmail }}
      </div>
    </div>
    <div class="flex justify-center pt-2">
      <Button @click="() => transition('emailInput')" class="w-full">
        {{ t("ok") }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'auth'
})

import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as z from "zod";
import { useI18n } from "vue-i18n";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { ref } from "vue";

const { t, locale } = useI18n();
const { transition, isState } = useForgetPasswordStateMachine();
const userEmail = ref("");
const config = useRuntimeConfig();
const authStore = useAuthStore()
const formSchema = toTypedSchema(
  z.object({
    email: z
      .string({ message: "required" })
      .min(1, { message: "required" })
      .email(t("forgetPassword.invalidEmail")),
  })
);

const { handleSubmit, resetForm, errors, setFieldError } = useForm({
  validationSchema: formSchema,
});


// userAccount	string	v			登入帳號
// email	string	v			電子信箱
// usertype	int	v		同Project Type (Key)	專案類別
// redirectUrl	string				自訂前綴網址
// is_enterprise	boolean			是否為從企業版管理後台而來	
// lang	string			Language (Code)	語言

const onSubmit = handleSubmit(async (values) => {
  // console.log("Forgot password for:", values.email);
  // 處理忘記密碼邏輯
  
  // 模擬 API 呼叫成功
  const userType = 7 // GSN
  userEmail.value = values.email;
  try {
    await $fetch(`${config.public.APIurl}/api/v3/password/forget`, 
      {
        method: "POST",
        body: {
          userAccount: values.email,
          email: values.email,
          usertype: userType,
          lang: locale.value,
          redirectUrl: location.origin + "/resetpassword?access="
        }
      }
    )
    transition('emailSent');
  }catch(error: any) {
    // console.log("Password reset error:", error.data);
    setFieldError("email", error.data?.message || t(error.data?.code));
  }
});


const onCancel = () => {
  // 處理取消邏輯
  navigateTo(config.public.GSNurl, {external: true});
};
</script>
<style scoped> 
.backgroundImg {
  height: 100vh;
  width: 100%;
  background-image: linear-gradient(
      149.47deg,
      rgba(39, 39, 39, 0.9) 0.47%,
      rgba(0, 0, 0, 0.9) 81.27%
    ),
    url("@/assets/images/login_background.svg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
